import { buildComparePath } from 'components/shared/Compare/compareUrl';
import { DatasetRef } from 'components/shared/Compare/types';

const byRelease = (a: DatasetRef, b: DatasetRef) => a.version.localeCompare(b.version, undefined, { numeric: true });

export const historyComparePath = (viewed: DatasetRef, other: DatasetRef): string => {
  const pair = byRelease(other, viewed) < 0 ? [other, viewed] : [viewed, other];
  return buildComparePath('impact-assessment', { version: pair[0].version, system_model: pair[0].systemModel }, pair);
};
